import 'rxjs';
import { Observable } from 'rxjs/Observable';
import actions, { JOB_INVITATIONS } from '../actions';

const jobInvitationsEpic = (action$, store, { api }) =>
    action$.ofType(JOB_INVITATIONS).mergeMap(action =>
        Observable.from(api.jobInvitations(action.payload))
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            .map(response => toAction(response))
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            .catch(() => Observable.of(errorAction())),
    );

const toAction = response =>
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    response ? actions.jobInvitationsSuccess(response.data) : errorAction();

const errorAction = () =>
    actions.jobInvitationsFailure('Problem sending invitations');

export default jobInvitationsEpic;
